export default __webpack_public_path__ + "static/media/outlined-and-flat.acb06b86.png";